import { useMemo } from 'react'

import { SummaryWrap, SummaryItem } from 'app/common/templates-next/report-template/summary'
import { SummaryRow } from 'app/components/common/reports/summary'
import { SubsidyActSummaryType } from 'app/dataTypes/reports/data/common/subsidies/act'

type SummaryValue = string | Array<string>
type SummaryRowData = Array<[string, SummaryValue]>

const translate = (key: keyof SubsidyActSummaryType): string => {
  if (key === 'totalKlassesSum') {
    return 'Итого в классах'
  }
  if (key === 'totalKlassesStudents') {
    return 'Кол-во учащихся в классах'
  }
  if (key === 'totalDayCaresSum') {
    return 'Итого в ГПД'
  }
  if (key === 'totalDayCaresStudents') {
    return 'Кол-во учащихся в ГПД'
  }
  if (key === 'totalSubsidyCount') {
    return 'Кол-во дотаций'
  }
  if (key === 'totalSum') {
    return 'ИТОГО'
  }
  if (key === 'totalStudents') {
    return 'Кол-во учащихся'
  }

  return undefined as never
}

const withCurrency = (value: string | undefined, currency: string) => `${value || '0,00'} ${currency}`

type Props = {
  summary: SubsidyActSummaryType
  currency: string
  pending?: boolean
}

export const Summary = ({ summary, currency, pending }: Props) => {
  const rows = useMemo<Array<SummaryRowData>>(() => {
    const {
      totalSum,
      totalStudents,
      totalSubsidyCount,
      totalKlassesSum,
      totalKlassesStudents,
      totalDayCaresSum,
      totalDayCaresStudents,
    } = summary || {}

    const row1: SummaryRowData = [
      [translate('totalKlassesSum'), withCurrency(totalKlassesSum, currency)],
      [translate('totalKlassesStudents'), String(totalKlassesStudents ?? 0)],
      [translate('totalDayCaresSum'), withCurrency(totalDayCaresSum, currency)],
      [translate('totalDayCaresStudents'), String(totalDayCaresStudents ?? 0)],
    ]

    const row2: SummaryRowData = [
      [translate('totalSum'), withCurrency(totalSum, currency)],
      [translate('totalStudents'), String(totalStudents ?? 0)],
      [translate('totalSubsidyCount'), String(totalSubsidyCount ?? 0)],
    ]

    return [row1, row2]
  }, [summary, currency])

  return (
    <SummaryWrap>
      {rows.map((row, i) => (
        <SummaryRow key={i}>
          {row.map(([title, value]) => (
            <SummaryItem
              key={title}
              title={title}
              value={value}
              pending={pending}
            />
          ))}
        </SummaryRow>
      ))}
    </SummaryWrap>
  )
}
